export default "__VITE_ASSET__4febe742__"